import {
  ToastContainer,
  toast,
  ToastOptions,
  ToastContent,
} from 'react-toastify'

const CustomToastContainer = () => (
  <ToastContainer
    position="top-right"
    theme="dark"
    limit={5}
    autoClose={5000}
    containerId="custom"
    hideProgressBar
    className="custom-notifications"
  />
)

const notify = (msg: ToastContent, options: ToastOptions<unknown>) =>
  toast(msg, {
    ...options,
    containerId: 'custom',
  })

export { CustomToastContainer, notify }
